// @flow
import { connect } from 'react-redux'
import type { Store } from '../../redux/ducks'
import { init } from '../../redux/ducks/leadforms/reducers'
import {
  open as openForm,
  patch as patchForm,
  reset as resetForm
} from '../../redux/ducks/leadformEdit/reducers'
import store from '../../redux/store'
import Table from './Table'
import _ from 'lodash'
import { putMedia } from '../../redux/ducks/media/operations'
import type { Leadform } from '../types'
import { singleCrop } from '../../redux/ducks/AdvertisementDataAdapter'
import { getCustomQuestions, getStockQuestions } from './FormContainer'

function mapStateToProps(state: Store) {
  return {
    items: state.leadforms.items
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onCreate: () => {
      const state: Store = store.getState()
      if (state.leadformEdit.id !== null) {
        dispatch(resetForm())
      }
      dispatch(openForm(null))
    },
    onInit: (items) => {
      dispatch(
        init({
          items: _.map(items, (item): Leadform => {
            const imageStoreId = putMedia(item.image)
            return {
              id: item.id,
              name: item.name,
              vkGroup: item.vk_public,
              fbGroup: item.fb_public,
              title: item.title,
              description: item.description,
              imageStoreId: imageStoreId,
              vkCrop: singleCrop(item.vk_crop),
              stockQuestions: getStockQuestions(item.questions),
              questions: getCustomQuestions(item.questions),
              privacyPolicyUrl: item.privacy_policy_url,
              confirmationText: item.confirmation_text
            }
          })
        })
      )
    },
    onEdit: (id: number | null) => {
      const state: Store = store.getState()
      const leadform = state.leadformEdit
      if (id !== leadform.id) {
        const item = _.find(state.leadforms.items, { id: id })
        if (item) {
          dispatch(resetForm())
          const fillData: Leadform = {
            id: item.id,
            name: item.name,
            vkGroup: item.vkGroup && { id: item.vkGroup.id, label: item.vkGroup.label },
            fbGroup: item.fbGroup && { id: item.fbGroup.id, label: item.fbGroup.label },
            title: item.title,
            description: item.description,
            imageStoreId: item.imageStoreId,
            vkCrop: item.vkCrop,
            stockQuestions: item.stockQuestions,
            questions: item.questions,
            privacyPolicyUrl: item.privacyPolicyUrl,
            confirmationText: item.confirmationText
          }
          dispatch(patchForm(fillData))
        }
      }
      dispatch(openForm(id))
    }
  }
}

const TableContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(Table)

export default TableContainer
